// src/screens/InventoryScreen.jsx
import { useState } from "react";
import { C, levelColor } from "../styles/tokens";
import { Badge, ProgressBar } from "../components/UI";
import { INVENTORY } from "../data/mockData";

export default function InventoryScreen() {
  const [inv, setInv] = useState(INVENTORY.map((b) => ({ ...b })));

  const getLevel = (u) =>
    u <= 3 ? "critical" : u <= 8 ? "low" : u <= 15 ? "normal" : "high";

  const adjust = (i, delta) =>
    setInv((prev) =>
      prev.map((b, idx) =>
        idx === i ? { ...b, units: Math.max(0, Math.min(b.max, b.units + delta)) } : b
      )
    );

  const total    = inv.reduce((a, b) => a + b.units, 0);
  const critical = inv.filter((b) => b.units <= 3).length;
  const adequate = inv.filter((b) => b.units > 8).length;

  return (
    <div className="fade-up" style={{ padding: 24 }}>
      {/* Summary */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 14, marginBottom: 24 }}>
        {[
          { label: "Total Units",     value: total,    color: C.blue    },
          { label: "Critical Groups", value: critical, color: C.primary },
          { label: "Adequate Groups", value: adequate, color: C.green   },
        ].map((s) => (
          <div key={s.label} className="card" style={{ padding: 18, textAlign: "center", borderTop: `3px solid ${s.color}` }}>
            <div className="syne" style={{ fontSize: 36, fontWeight: 900, color: s.color }}>{s.value}</div>
            <div style={{ fontSize: 12, color: C.muted, marginTop: 2 }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Inventory list */}
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {inv.map((b, i) => {
          const level = getLevel(b.units);
          const color = levelColor(level);
          const pct   = (b.units / b.max) * 100;

          return (
            <div key={b.group} className="card" style={{ padding: 20, borderLeft: `3px solid ${color}` }}>
              <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
                {/* Badge */}
                <div style={{ width: 56, height: 56, background: `${color}15`, border: `1.5px solid ${color}40`, borderRadius: 14, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <span className="syne" style={{ fontSize: 17, fontWeight: 900, color }}>{b.group}</span>
                </div>

                {/* Progress */}
                <div style={{ flex: 1, minWidth: 180 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                    <span style={{ fontSize: 14, fontWeight: 700, color: C.text }}>{b.units} / {b.max} units</span>
                    <Badge label={level.charAt(0).toUpperCase() + level.slice(1)} color={color} />
                  </div>
                  <ProgressBar value={b.units} max={b.max} color={color} />
                  <div style={{ fontSize: 11, color: C.muted, marginTop: 4 }}>{pct.toFixed(0)}% capacity</div>
                </div>

                {/* Stepper */}
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <button
                    onClick={() => adjust(i, -1)}
                    disabled={b.units === 0}
                    style={{ width: 34, height: 34, background: `${color}15`, border: `1px solid ${color}40`, borderRadius: 9, cursor: "pointer", color, fontSize: 18, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center" }}
                  >−</button>
                  <div style={{ width: 48, height: 34, background: `${color}12`, borderRadius: 9, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <span style={{ color, fontSize: 16, fontWeight: 900 }}>{b.units}</span>
                  </div>
                  <button
                    onClick={() => adjust(i, 1)}
                    disabled={b.units === b.max}
                    style={{ width: 34, height: 34, background: `${color}15`, border: `1px solid ${color}40`, borderRadius: 9, cursor: "pointer", color, fontSize: 18, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center" }}
                  >+</button>
                  <button className="btn-sm" style={{ marginLeft: 8 }}>Update</button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}